<template>
  <sign-page
    title-text="公文管理"
    :request="request"
    table-size="large"
    :title-menus="[{key: 'new', label: '新增'}]"
    :tableActions="tableActions"
    @clickTitleMenu="chooseData=null;modal = true"
    @tableAction="tableAction"
    :column-list="columnList"
    ref="docPage"
    :table-actions-fixed="true"
    :tableActionsWidth="200"
    :need-data-file="true">
    <fm-modal v-model="modal" v-if="modal" width="1100px">
      <doc-form :id="chooseData ? chooseData.id : null" @dataUpdate="$refs.docPage.loadData()" @close="modal = false" :workerList="$store.getters.allWorkerList" v-if="modal"></doc-form>
    </fm-modal>
  </sign-page>
</template>

<script>
import DocForm from './cmp/form'
import DocTitle from './cmp/docTitle'
import {
  officialDocumentRequest as request
} from '@/api'

export default {
  components: {
    DocForm
  },
  created () {
    this.$store.dispatch('loadAllWorkerList')
  },
  methods: {
    async tableAction (parm) {
      this.chooseData = parm.data
      let action = parm.action
      if (action === 'edit_all') {
        this.modal = true
      } else if (action === 'over') {
        this.chooseData.status = 'over'
        await request.update(this.chooseData.id, this.chooseData)
        this.$notice.success({
          title: '系统提示',
          desc: '公文已结束。'
        })
        this.$refs.docPage.loadData()
      } else if (action === 'detail') {
        this.$router.push({
          name: 'doc.detail',
          query: {
            id: this.chooseData.id
          }
        })
      } else if (action === 'back') {
        await request.back(this.chooseData.id)
        this.$notice.success({
          title: '系统提示',
          desc: '公文可继续处理。'
        })
        this.$refs.docPage.loadData()
      }
    }
  },
  computed: {
    tableActions () {
      return [{
        key: 'edit_all',
        label: '编辑',
        show (data) {
          return data.status === 'doing'
        }
      },
      {
        key: 'detail',
        label: '查看'
      },
      {
        key: 'back',
        label: '继续处理',
        show (data) {
          return data.status === 'over'
        }
      },
      {
        key: 'over',
        label: '结束',
        show (data) {
          return data.status === 'doing'
        }
      },
      {
        key: 'del',
        label: '删除',
        show (data) {
          return data.status === 'doing'
        }
      }]
    },
    columnList: {
      get () {
        let data = [{
          title: '编码',
          sort: true,
          field: 'id'
        },
        {
          title: '标题',
          sort: true,
          field: 'title',
          render: (h, row) => {
            return h(DocTitle, {
              props: {
                title: row.title
              }
            })
          }
        },
        {
          title: '来文单位',
          sort: true,
          field: 'sendOrgName'
        },
        {
          title: '来文份数',
          sort: true,
          field: 'num',
          dataType: Number
        },
        {
          title: '来文日期',
          sort: true,
          field: 'sendTime',
          dataType: Date,
          render: (h, rowData) => {
            return h('div', rowData && rowData.sendTime ? rowData.sendTime.slice(0, 10) : '-')
          }
        },
        {
          title: '来文号',
          sort: true,
          field: 'sendCode'
        },
        {
          title: '收文日期',
          sort: true,
          field: 'getTime',
          dataType: Date,
          render: (h, rowData) => {
            return h('div', rowData && rowData.getTime ? rowData.getTime.slice(0, 10) : '-')
          }
        },
        {
          title: '收文编号',
          sort: true,
          field: 'getCode'
        },
        {
          title: '状态',
          sort: true,
          field: 'status',
          render: (h, rowData) => {
            return h('div', rowData && rowData.status === 'doing' ? '未结束' : '已结束')
          }
        }]
        return data
      }
    }
  },
  data () {
    return {
      request: request,
      chooseData: null,
      modal: false
    }
  }
}
</script>
